<template>
  <div class="home">
    <div v-permission="'设备总览'">
      <h5>设备总览</h5>
      <div class="h_equip_overview">
        <ul>
          <li v-for="(item, key) in equipStatus" :key="key">
            <el-tooltip class="item" placement="right" effect="light">
              <div>
                <i :class="['iconfont', item.icon]" :style="{color:item.color}"></i>
                <dl>
                  <dt>{{item.statu_desp}}</dt>
                  <dd>{{item.num}}</dd>
                </dl>
              </div>
              <div slot="content">
                <ol class="h_tooltip">
                  <li v-for="(val, key) in item.detail" :key="key">
                    <span>{{deviceTypes[key]}}:</span> {{val}}</li>
                </ol>
              </div>
            </el-tooltip>
          </li>
        </ul>
      </div>
    </div>

    <div class="h_title" v-if="hasRight('昨日新增数据') || hasRight('总览数据')">
      <ul>
        <li v-for="item in machineTypeList" :key="item.key" :class="{actived :item.key === machineTypeSelect}" @click="machineTypeChange(item.key)">{{item.name}}</li>
      </ul>
    </div>

    <div class="h_production">
      <div v-permission="'昨日新增数据'">
        <h6>昨日新增</h6>
        <ul>
          <li v-for="(it, key) in yesterdayData" :key="key">
            <dl>
              <dt>{{it.num}}</dt>
              <dd :style="{color: it.color}">{{it.statu_desp}}</dd>
            </dl>
          </li>
        </ul>
      </div>
      <div v-permission="'总览数据'">
        <h6>{{workDigestTitle}}总览</h6>
        <ul>
          <li v-for="(it, key) in workDigest" :key="key">
            <dl>
              <dt>{{it.num}}</dt>
              <dd :style="{color: it.color}">{{it.statu_desp}}</dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>

    <div class="h_statistic"
      v-permission="'折线图统计数据'"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <el-button v-for="it in list" :key="it.key" :class="['btn', params.data_type === it.key ? 'btn_1' : 'btn_2']" @click="statisTypeChoose(it.key)">{{it.name}}</el-button>

      <ol>
        <li :class="{'actived': params.date_type === dateTypes.NOW_WEEK.value}" @click="dateTypeChoose('NOW_WEEK')">本周</li>
        <li :class="{'actived': params.date_type === dateTypes.NOW_MONTH.value}" @click="dateTypeChoose('NOW_MONTH')">本月</li>
        <li>
          <el-date-picker
            style="width: 140px;"
            v-model="params.query_date"
            type="month"
            placeholder="选择月"
            :clearable="false"
            @change="dateChange"
            value-format="yyyy-MM"
            :picker-options="pickerOptions">
          </el-date-picker>
        </li>
      </ol>

      <div class="h_statistic_content">
        <div class="h_s_c_total">
          <dl>
            <dt>本月</dt>
            <dd>{{ statisticsName }}总数</dd>
            <dd>{{statisticsTotal.month}}</dd>
          </dl>
          <dl>
            <dt>本周</dt>
            <dd>{{ statisticsName }}总数</dd>
            <dd>{{statisticsTotal.week}}</dd>
          </dl>
        </div>

        <echart-component class="h_s_c_echart" :data="statisticsData" />
      </div>
    </div>
  </div>
</template>

<script>
import Backend from '@/api/backend'
import echartComponent from './echart.vue'
import BasicDataHelper from '@/api/basic_data_helper'
import { hasRight } from '../../api/permission'

export default {
  name: '',
  data () {
    return {
      hasRight: hasRight,
      equipStatus: {
        connected: {
          icon: 'icon-zaixian-xian',
          statu_desp: '在线',
          num: 0,
          color: '#1BC6D7',
          detail: null
        },
        disconnected: {
          icon: 'icon-lixian-xian',
          statu_desp: '离线',
          num: 0,
          color: '#B7B7B7',
          detail: null
        },
        waring: {
          icon: 'icon-taizhanguzhang',
          statu_desp: '故障',
          num: 0,
          color: '#FF00A8',
          detail: null
        },
        total: {
          icon: 'icon-quanbu_huaban',
          statu_desp: '全部',
          num: 0,
          color: '#1B61D7',
          detail: null
        }
      },
      machineTypeList: [
        {
          name: '制片机',
          key: 1
        },
        {
          name: '扫描仪',
          key: 2
        },
        {
          name: 'AI服务器',
          key: 3
        }
      ],
      machineTypeSelect: 1,
      yesterdayData: null,
      workDigest: null,
      workDigestTitle: '制片',
      lbpYesterdayData: {
        work_count: {
          statu_desp: '制片数量',
          num: 0,
          color: '#01B79F'
        },
        warning_count: {
          statu_desp: '报警数量',
          num: 0,
          color: '#1B93D7'
        }
      },
      lbpWorkDigest: {
        lastMonth: {
          statu_desp: '上月新增',
          num: 0,
          color: '#1B93D7'
        },
        total: {
          statu_desp: '制片总数',
          num: 0,
          color: '#5F65F1'
        }
      },
      scanYesterdayData: {
        work_count: {
          statu_desp: '扫描数量',
          num: 0,
          color: '#01B79F'
        },
        warning_count: {
          statu_desp: '报警数量',
          num: 0,
          color: '#1B93D7'
        }
      },
      scanWorkDigest: {
        lastMonth: {
          statu_desp: '上月新增',
          num: 0,
          color: '#1B93D7'
        },
        total: {
          statu_desp: '扫描总数',
          num: 0,
          color: '#5F65F1'
        }
      },
      aiYesterdayData: {
        work_count: {
          statu_desp: '分析数量',
          num: 0,
          color: '#01B79F'
        },
        warning_count: {
          statu_desp: '报警数量',
          num: 0,
          color: '#1B93D7'
        }
      },
      aiWorkDigest: {
        lastMonth: {
          statu_desp: '上月新增',
          num: 0,
          color: '#1B93D7'
        },
        total: {
          statu_desp: '分析总数',
          num: 0,
          color: '#5F65F1'
        }
      },
      list: [
        {
          name: '制片统计',
          key: 1
        },
        {
          name: '报警统计',
          key: 2
        },
        {
          name: '扫描统计',
          key: 3
        },
        {
          name: 'AI分析统计',
          key: 4
        }
      ],
      deviceTypes: BasicDataHelper.DeviceTypes,
      dateTypes: BasicDataHelper.DateTypes,
      statisticsName: '',
      params: {
        data_type: 1,
        date_type: BasicDataHelper.DateTypes.NOW_MONTH.value,
        query_date: ''
      },
      loading: false,
      statisticsData: null,
      statisticsTotal: {
        month: 0,
        week: 0
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  components: {
    'echart-component': echartComponent
  },

  created () {
    this.getEquipStatus()

    this.machineTypeChange(1)
    for (let i = 1; i < 4; i++) {
      this.getYesterdayData(i)
      this.getWorkDigest(i)
    }

    if (hasRight('折线图统计数据')) this.getStatisticsData()
  },

  methods: {
    getEquipStatus () {
      if (hasRight('设备总览')) {
        Backend.post(this, 'statistics/device_digest').then((data) => {
          for (const k in data) {
            this.equipStatus[k].detail = data[k]
            for (const key in data[k]) {
              this.equipStatus[k].num += data[k][key]
            }
          }
        })
      }
    },
    getYesterdayData (type) {
      if (hasRight('昨日新增数据')) {
        Backend.post(this, 'statistics/yesterday_data', { device_type: type }).then((data) => {
          for (const k in data) {
            this[type === 1 ? 'scanYesterdayData' : type === 2 ? 'lbpYesterdayData' : type === 3 ? 'aiYesterdayData' : ''][k].num = data[k]
          }
        })
      }
    },
    getWorkDigest (type) {
      if (hasRight('总览数据')) {
        Backend.post(this, 'statistics/work_digest', { device_type: type }).then((data) => {
          for (const k in data) {
            this[type === 1 ? 'scanWorkDigest' : type === 2 ? 'lbpWorkDigest' : type === 3 ? 'aiWorkDigest' : ''][k].num = data[k]
          }
        })
      }
    },
    getStatisticsData () {
      if (hasRight('折线图统计数据')) {
        this.loading = true
        Backend.post(this, 'statistics/index_line_chart', this.params).then((data) => {
          this.statisticsTotal.month = data.current_month
          this.statisticsTotal.week = data.current_week
          this.statisticsData = data.data
          this.loading = false
        })
      }
    },
    machineTypeChange (key) {
      this.machineTypeSelect = key
      this.yesterdayData = key === 1 ? this.lbpYesterdayData : key === 2 ? this.scanYesterdayData : key === 3 ? this.aiYesterdayData : {}
      this.workDigest = key === 1 ? this.lbpWorkDigest : key === 2 ? this.scanWorkDigest : key === 3 ? this.aiWorkDigest : {}
      this.workDigestTitle = key === 1 ? '制片' : key === 2 ? '扫描' : key === 3 ? 'AI分析' : ''
    },
    statisTypeChoose (key) {
      this.params.data_type = key
      this.statisticsName = key === 1 ? '制片' : key === 2 ? '故障' : key === 3 ? '扫描' : key === 4 ? '分析' : ''
      this.params.date_type = this.dateTypes.NOW_MONTH.value
      this.params.query_date = ''
      this.getStatisticsData()
    },
    dateTypeChoose (type) {
      this.params.date_type = this.dateTypes[type].value
      this.params.query_date = ''
      this.getStatisticsData()
    },
    dateChange () {
      this.params.date_type = this.dateTypes.MONTH.value
      this.getStatisticsData()
    }
  }
}
</script>

<style lang='scss' scoped>
  h5{
    font-size: 16px;
    margin-bottom: 10px;
  }
  h6{
    color: #333333;
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 10px;
  }
  ul{
    display: flex;
    li{
      float: left;
      display: flex;
      justify-content: center;
    }
  }
  dl{
    display: inline-block;
  }
  .h_title{
    ul{
      li{
        float: left;
        margin-right: 14px;
        font-weight: bold;
        line-height: 36px;
        cursor: pointer;
        &::after{
          content: '/';
          padding-left: 14px;
        }
        &:last-child{
          &::after{
            content: '';
          }
        }
      }.actived{
        color: #1BC6D7;
      }
    }
  }
  .h_equip_overview{
    background: #FFFFFF;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 30px 0;
    i{
      margin-right: 10px;
      font-size: 48px;
    }
    ul{
      li{
        flex: 1;
        padding: 10px 0;
        border-right: 1px solid #DCDCDC;
        &:last-child{
          border: unset;
        }
      }
    }
    dl{
      dt{
        font-size: 14px;
        color: #666666;
      }
      dd{
        color: #333333;
        font-size: 38px
      }
    }
  }
  .h_production{
    display: flex;
    div{
      flex: 1;
      background: #FFFFFF;
      border-radius: 10px;
      padding: 20px;
      &:first-child{
        margin-right: 10px;
      }
    }
    ul{
      display: flex;
      li{
        flex: 1;
        dl{
          text-align: center;
          dt{
            font-size: 34px;
            color: #333333;
            padding-bottom: 10px;
          }
          dd{
            font-size: 16px;
          }
        }
        // &::before{
        //   content: '';
        //   width: 1px;
        //   height: 39px;
        //   background-color: #DCDCDC;
        // }
      }
    }
  }
  .h_statistic{
    margin-top: 10px;
    padding: 20px;
    background: #FFFFFF;
    border-radius: 10px;
    position: relative;
    ol{
      position: absolute;
      top: 20px;
      right: 20px;
      display: inline-flex;
      align-items: center;
      li{
        float: left;
        cursor: pointer;
        margin-right: 16px;
        color: #999999;
        font-size: 14px;
      }.actived{
        color: #1BC6D7;
      }
    }
    .h_statistic_content{
      display: flex;
      .h_s_c_total{
        width: 100px;
        padding-top: 50px;
        dl{
          width: 100%;
          margin-bottom: 20px;
          dt,dd{
            padding-bottom: 8px;
          }
          dt{
            color: #333333;
          }
          dd{
            color:#999999;
            &:last-child{
              font-size: 20px;
              color:#5F65F1;
            }
          }
        }
      }
      .h_s_c_echart{
        flex: 1;
      }
    }
  }
  .h_tooltip{
    font-size: 16px;
    li{
      margin-bottom: 6px;
      color: #db5656;
      span{
        width: 76px;
        display: inline-block;
        color: #538be6;
      }
    }
  }
</style>
